<template>
  <div>
    <v-menu
      v-if="isLoggedIn"
      open-on-click
      :close-on-content-click="false"
      nudge-left="50"
      offset-y
      height="750"
      max-height="85%"
      style="z-index: 15"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="updateTabs()">
          <v-badge color="red" overlap>
            <template v-slot:badge v-if="unread > 0">
              <span>{{ unread > 99 ? "99+" : unread }}</span>
            </template>
            <v-icon :color="count ? '#eee' : 'grey'" large>
              {{ unread ? "notifications_active" : "notifications_none" }}
            </v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-card width="500" max-width="100%">
        <div v-if="count == 0" class="text-xs-center pa-5 my-2">
          <v-spacer></v-spacer>
          <v-icon size="64" color="#ccc" center>notifications_none</v-icon>
          <div class="headline my-3">No Notification!</div>
          <span>
            Hit the refresh button below to get latest notifications if any.
          </span>
        </div>

        <v-tabs
          v-else
          v-model="activeTab"
          grow
          color="transparent"
          class="pa-1"
          ref="tabs"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            href="#investor"
            :disabled="investorNotifications.length == 0 ? true : false"
            key="investor"
            class="primary--text"
          >
            <!-- <v-badge
                            color="red">
                            <template
                                v-slot:badge
                                v-if = "investorNotifications.length > 0">
                                <span>{{ investorNotifications.length > 9 ? "99+" : investorNotifications.length }}</span>
                            </template>
                        </v-badge> -->
            Investor
          </v-tab>
          <v-tab
            href="#investee"
            :disabled="investeeNotifications.length == 0 ? true : false"
            key="investee"
            class="primary--text"
          >
            <!-- <v-badge
                            color="red">
                            <template
                                v-slot:badge
                                v-if = "investeeNotifications.length > 0">
                                <span>{{ investeeNotifications.length }}</span>
                            </template>
                        </v-badge> -->
            Investee
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item value="investor" key="investor">
            <v-list three-line>
              <v-list-tile
                v-for="notification in investorNotifications"
                :key="notification.id"
                icon
                class="notification"
              >
                <v-list-tile-avatar>
                  <v-icon
                    :class="notification.data.color || 'grey'"
                    class="white--text"
                  >
                    {{ notification.data.icon || "notifications" }}
                  </v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ notification.data.title }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title
                    :class="notification.read_at || 'unread'"
                  >
                    {{ notification.data.message }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-list-tile-action-text>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ timeAgo(notification.created_at) }}
                        </span>
                      </template>
                      <span>{{ notification.created_at }}</span>
                    </v-tooltip>
                  </v-list-tile-action-text>
                  <v-btn
                    :loading="isDeleting(notification.id)"
                    @click="deleteNotification(notification.id)"
                    icon
                    :ripple="{ class: 'red--text' }"
                    class="delete"
                  >
                    <v-icon color="grey lighten-1" title="Delete">
                      delete
                    </v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-tab-item>
          <v-tab-item value="investee" key="investee">
            <v-list three-line>
              <v-list-tile
                v-for="notification in investeeNotifications"
                :key="notification.id"
                icon
                class="notification"
              >
                <v-list-tile-avatar>
                  <v-icon
                    :class="notification.data.color || 'grey'"
                    class="white--text"
                  >
                    {{ notification.data.icon || "notifications" }}
                  </v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ notification.data.title }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title
                    :class="notification.read_at || 'unread'"
                  >
                    {{ notification.data.message }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-list-tile-action-text>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ timeAgo(notification.created_at) }}
                        </span>
                      </template>
                      <span>{{ notification.created_at }}</span>
                    </v-tooltip>
                  </v-list-tile-action-text>
                  <v-btn
                    :loading="isDeleting(notification.id)"
                    @click="deleteNotification(notification.id)"
                    icon
                    :ripple="{ class: 'red--text' }"
                    class="delete"
                  >
                    <v-icon color="grey lighten-1" title="Delete">
                      delete
                    </v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-tab-item>
        </v-tabs-items>

        <v-card-actions class="justify-center">
          <v-btn
            :loading="isNotifications.loadingMore"
            :disabled="disableLoadMore"
            flat
            color="primary"
            @click="loadMoreNotifications"
          >
            <v-icon title="Load More">playlist_add</v-icon>
          </v-btn>

          <v-btn
            :loading="isNotifications.loading"
            :disabled="isNotifications.loading"
            flat
            color="primary"
            @click="refreshNotifications"
          >
            <v-icon title="Refresh">refresh</v-icon>
          </v-btn>

          <v-btn
            :disabled="count == 0"
            flat
            color="red lighten-1"
            @click="promtDeleteAll = true"
          >
            <v-icon title="Delete All">delete_sweep</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-dialog v-model="promtDeleteAll" persistent width="450">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>

        <v-card-text>
          <v-alert :value="true" color="error lighten-1" icon="delete">
            You are about to delete all notifications. This action is
            irreversible.
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary lighten-1" flat @click="promtDeleteAll = false">
            Cancel
          </v-btn>
          <v-btn
            :loading="isNotifications.deletingAll"
            color="red dark"
            flat
            @click="deleteAllNotifications"
          >
            Yes, Delete All
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<style scoped>
  .notification:hover {
    background-color: #eee;
  }

  .notification .delete:hover .v-icon {
    color: #e57373 !important;
  }

  .notification .v-list__tile__action--stack {
    justify-content: space-around;
  }

  .v-tabs__slider-wrapper {
    min-width: 50% !important;
  }
</style>

<script>
  import { mapGetters } from "vuex";
  // Firebase config
  import messaging from "../../firebase";
  import { onMessage } from "firebase/messaging";

  export default {
    name: "ShadhinNotifications",

    data() {
      return {
        deletingId: "",
        promtDeleteAll: false,
        activeTab: null,
        isTabsRefreshNeeded: false,

        snackbar: false,
        y: "bottom",
        x: "",
        mode: "",
        timeout: 5000,
        text: "",
        bottom: true,
      };
    },

    created() {
      this.ongoingRefreshNotifications();

      // When web app is in the foreground, if firebase notifications come, reload notifications
      onMessage(messaging, (payload) => {
        // console.log("Message received. ", payload);
        this.text = payload;
        this.snackbar = true;
        this.$store.dispatch("getNotifications", 1);
      });
    },

    mounted() {
      this.refreshNotifications();
    },

    watch: {
      count: function () {
        this.isTabsRefreshNeeded = this.count ? true : false;
      },
    },

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "notifications",
        "notificationsMeta",
        "isNotifications",
      ]),

      count: function () {
        return this.notificationsMeta.total;
      },

      unread: function () {
        return this.notificationsMeta.total_unread;
      },

      disableLoadMore: function () {
        return (
          this.notificationsMeta.current_page ==
          this.notificationsMeta.last_page
        );
      },

      investorNotifications: function () {
        return this.notifications.filter((notification) => {
          return notification.data.type == "investor";
        });
      },

      investeeNotifications: function () {
        return this.notifications.filter((notification) => {
          return notification.data.type == "investee";
        });
      },
    },

    methods: {
      refreshNotifications() {
        this.$store.dispatch("getNotifications", 1);
      },

      ongoingRefreshNotifications() {
        let _this = this;
        setTimeout(function () {
          _this.refreshNotifications();
          _this.ongoingRefreshNotifications();
        }, 1000 * 60 * 5); // Every 5 minutes
      },

      loadMoreNotifications() {
        this.$store.dispatch(
          "getNotifications",
          this.notificationsMeta.current_page + 1
        );
      },

      readNotification(notificationId) {
        let _this = this;

        this.readId = notificationId;

        this.$store
          .dispatch("readNotification", notificationId)
          .then(function () {
            _this.readId = "";
          });
      },

      readNotificationAll() {
        let _this = this;
        this.$store.dispatch("readAllNotifications").then(function () {
          _this.count = 0;
        });
      },

      deleteAllNotifications() {
        let _this = this;

        this.$store.dispatch("deleteAllNotifications").then(function () {
          _this.promtDeleteAll = false;
        });
      },

      deleteNotification(notificationId) {
        let _this = this;

        this.deletingId = notificationId;

        this.$store
          .dispatch("deleteNotification", notificationId)
          .then(function () {
            _this.deletingId = "";
          });
      },

      isDeleting(notificationId) {
        if (
          this.deletingId == notificationId &&
          this.isNotifications.deleting
        ) {
          return true;
        }
      },

      timeAgo(time) {
        // Add GMT+6 to the time string.
        // Otherwise, it will show wrong value on
        // a computer with different timezone
        time += " GMT+6";

        // Time Difference in Minutes (60*1000)
        let timeDiff = (Date.now() - Date.parse(time)) / 60000;

        let number, text;

        if (timeDiff < 60) {
          number = timeDiff.toFixed(0);
          text = number + " minute";
        } else if (timeDiff < 60 * 24) {
          number = (timeDiff / 60).toFixed(0);
          text = number + " hour";
        } else if (timeDiff < 60 * 24 * 30) {
          number = (timeDiff / (60 * 24)).toFixed(0);
          text = number + " day";
        } else if (timeDiff < 60 * 24 * 365) {
          number = (timeDiff / (60 * 24 * 30)).toFixed(0);
          text = number + " month";
        } else {
          number = (timeDiff / (60 * 24 * 365)).toFixed(0);
          text = number + " year";
        }

        return number > 1 ? text + "s" : text;
      },

      updateTabs() {
        let _this = this;
        if (this.isTabsRefreshNeeded) {
          setTimeout(function () {
            // Update tabs slider
            _this.$refs.tabs.callSlider();

            // Update investee tab items when investor tab is empty
            if (
              _this.investorNotifications.length == 0 &&
              _this.activeTab == "investor"
            ) {
              _this.activeTab = "investee";
            }
          }, 500);
          if (this.count) {
            this.readNotificationAll();
          }
          this.isTabsRefreshNeeded = false;
        }
      },
    },
  };
</script>
<style scoped>
  .theme--light.v-list .v-list__tile__sub-title.unread {
    color: #000;
  }
</style>
